/***
 *
 *   MODAL
 *   Display an overlay modal anywhere in your application by calling
 *   context.modal.show() with an object containing the following props
 *
 *   PROPS
 *   title: (optional)
 *   text: message to the user (optional)
 *   form: a form object (optional: see form docs for more information)
 *   url: destination to send the form
 *   method: HTTP post type
 *   buttonText – text for the confirm button
 *
 **********/

import React, { useContext, useRef } from 'react';
import { Text } from '@chakra-ui/react';
import { ViewContext, Card, Form } from 'components/lib';
import { CSSTransition } from 'react-transition-group';
import './modal.scss';

export function Modal(props) {
  const context = useContext(ViewContext);
  // nodeRef fix: https://github.com/reactjs/react-transition-group/blob/1fd4a65ac45edd2aea3dec18eeb8b9c07c7eb93f/CHANGELOG.md#features
  const nodeRef = useRef(null);

  return (
    <CSSTransition in appear timeout={0} classNames="modal" nodeRef={nodeRef}>
      <div ref={nodeRef} className="modal" onClick={(e) => e.target === e.currentTarget}>
        <div className="modal-content">
          <Card>
            {props.title && (
              <header>
                <h1>{props.title}</h1>
              </header>
            )}

            {props.text && <Text mb="16px">{props.text}</Text>}

            {props.form && (
              <Form
                method={props.method}
                url={props.url}
                data={props.form}
                buttonText={props.buttonText}
                cancel={(e) => context.modal.hide(true)}
                hideCancel={props.hideCancel}
                callback={props.callback}
                redirect={props.redirect}
                notification={props.notification}
              />
            )}
          </Card>
        </div>
      </div>
    </CSSTransition>
  );
}
